import React from 'react';
import { Link } from 'react-router-dom';

function Success() {
  return (
    <div className="theme-copy-page result-page container mx-auto px-4 py-16">
      <div className="max-w-md mx-auto text-center">
        <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-12 h-12 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-4xl font-bold text-gray-800 mb-4">Payment Successful!</h1>
        <p className="text-gray-600 mb-2">Thank you for your rental booking.</p>
        <p className="text-gray-600 mb-8">
          We've sent a confirmation email with all the details. You'll receive your booking reference shortly.
        </p>
        <div className="space-y-3">
          <Link
            to="/home"
            className="block w-full px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition font-medium"
          >
            Return to Home
          </Link>
          <Link
            to="/vehicles"
            className="block w-full px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition font-medium"
          >
            Browse More Vehicles
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Success;
